<div *ngIf="tenants.length > 1" class="fixed z-50" aria-labelledby="raise-ticket-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-[#363738] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]"
    (click)="closeModal.emit()"></div>
  <div class="fixed inset-0 flex items-center justify-center p-4">
    <div
      class="relative flex max-h-[80vh] w-full max-w-md flex-col rounded-lg border border-zinc-950/10 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950">
      <div class="flex items-center justify-between border-b border-zinc-200 px-4 py-2 dark:border-white/10">
        <h3 class="heading" id="raise-ticket-title">Raise Ticket For</h3>
        <button (click)="closeModal.emit()" type="button"
          class="rounded-md bg-white text-zinc-500 hover:text-zinc-700 focus:ring-2 focus:ring-primary dark:bg-white/5 dark:text-white dark:hover:text-zinc-300">
          <span class="sr-only">Close</span>
          <svg aria-hidden="true" class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.5"
            viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
      </div>

      <!-- Content -->
      <ul class="overflow-y-auto divide-y divide-zinc-200 dark:divide-white/10">
        <li *ngFor="let tenant of tenants">
          <label class="flex w-full cursor-pointer items-center gap-3 px-4 py-2 hover:bg-gray-950/5 dark:hover:bg-white/10">
            <input type="checkbox" [(ngModel)]="tenant.isSelected" class="w-4 h-4 accent-main-base cursor-pointer" />
            <span [ngClass]="tenant.badge">{{ tenant.label }}</span>
            <span class="text-sm-dark">{{ (tenant.name | titlecase) || 'N/A' }}</span>
          </label>
        </li>
      </ul>

      <!-- Footer -->
      <div class="flex justify-end gap-3 border-t border-zinc-200 px-4 py-2 dark:border-white/10">
        <button type="button" (click)="closeModal.emit()" class="btn-outline btn-outline-secondary">
          Cancel
        </button>
        <button type="button" (click)="onSubmit()" [disabled]="!selectedTenants.length"
          class="btn btn-primary disabled:opacity-50 disabled:cursor-not-allowed">
          Raise Ticket
        </button>
      </div>
    </div>
  </div>
</div>
